import { H3, P, PromotionTile, Section, Small } from '@ahmdigital/ui';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';

import buildYourCoverActions, { BuildYourCoverProductType } from '../../../../../../actions/build-your-cover';
import styles from './styles.module.sass';

type AddOnsProps = {
  illustrationsBox: ReactNode;
  description: string;
  title: string;
  link: { label: string; url: string };
  productType: BuildYourCoverProductType;
};

const AddOns = ({ illustrationsBox, description, title, link, productType }: AddOnsProps) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(buildYourCoverActions.setAddOnType(productType));
  };

  return (
    <Section variant={['marginTopSpacerNone', 'paddingTopSpacerNone']}>
      <H3 looksLike="h5" variant="marginBottomSpacer10">
        Looking for more?
      </H3>
      <PromotionTile
        className={styles.extrasWrapper}
        description={description}
        link={{ hasIcon: true, onClick: handleClick, text: link.label, url: link.url }}
        title={title}
        label="Optional"
        righthandContent={illustrationsBox}
      />
      {productType === PRODUCT_TYPE.HOSPITAL && (
        <div
          className={styles.medicallyNecessaryAmbulanceDisclaimer}
          data-testId="medically-necessary-ambulance-disclaimer"
        >
          <Small variant="bold">Unlimited Medically Necessary Ambulance</Small>
          <P>
            ^Transport to the nearest hospital provided by an ahm approved road, sea or air Ambulance provider that’s
            able to provide the level of care you medically need. Some ahm products limit the number of Ambulance
            services we’ll pay benefits towards per financial year. Check your product information to see if any limits
            apply. Your Daily Charge and/or Excess doesn’t apply to Ambulance claims.
          </P>
        </div>
      )}
    </Section>
  );
};

export default AddOns;
